import { z } from "zod";

const httpUrl = z
  .string()
  .regex(/^https?:\/\//, "must start with http:// or https://");

const environmentSchema = z.object({
  ENVIRONMENT: z.string().min(1),
  AGROEVIDENCE_URL: httpUrl,
  AUTOMATION_URL: httpUrl,
  GATEWAY_URL: httpUrl,
  GEOLAYERS_URL: httpUrl,
  IOT_URL: httpUrl,
  IRRIGATION_URL: httpUrl,
  MAPTILER_API_KEY: z.string(),
  SATELLITE_REPORTS_URL: httpUrl,
  SATELLITE_URL: httpUrl,
  STORES_URL: httpUrl,
  TELEMATICS_URL: httpUrl,
});

type Environment = z.infer<typeof environmentSchema>;

// Browser reads the build-time `window.ENV` injected by vite; the `check:env`
// node script parses `process.env` (dotenv-loaded) — same schema, both fail
// fast on a missing/malformed var.
const source: unknown =
  typeof window !== "undefined" && window.ENV ? window.ENV : process.env;

const parsed = environmentSchema.safeParse(source);

if (!parsed.success) {
  const details = parsed.error.issues
    .map((issue) => `  ${issue.path.join(".") || "(root)"}: ${issue.message}`)
    .join("\n");
  throw new Error(`Invalid runtime environment configuration:\n${details}`);
}

const env = parsed.data;

export { env, type Environment };
